export default __webpack_public_path__ + "static/media/adylic-stacked-logo.ef971ff8.png";